module.exports = __webpack_public_path__ + "img/logo.f89c885f.png";